(function() {
  function initCollection(root) {
    /* ── Mobile filter drawer ── */
    var filterBtn   = root.querySelector('[data-filter-open]');
    var filterPanel = root.querySelector('[data-filter-panel]');
    var filterClose = root.querySelector('[data-filter-close]');
    var overlay     = root.querySelector('[data-filter-overlay]');

    function openFilters() {
      if (!filterPanel) return;
      filterPanel.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeFilters() {
      if (!filterPanel) return;
      filterPanel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    if (filterBtn)   filterBtn.addEventListener('click', openFilters);
    if (filterClose) filterClose.addEventListener('click', closeFilters);
    if (overlay)     overlay.addEventListener('click', closeFilters);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeFilters();
    });

    /* ── Sort: auto-submit on change ── */
    var sortSelect = root.querySelector('[data-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ── Load more (AJAX) ── */
    var loadMoreBtn = root.querySelector('[data-load-more]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var href = this.getAttribute('href');
        if (!href) return;
        var btn = this;
        btn.textContent = 'Loading...';
        btn.classList.add('is-loading');

        fetch(href)
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc     = new DOMParser().parseFromString(html, 'text/html');
            var newRoot = doc.querySelector('[data-kb-col]');
            if (!newRoot) throw new Error('not found');

            var newGrid     = newRoot.querySelector('[data-grid]');
            var newLoadMore = newRoot.querySelector('[data-load-more]');
            var grid        = root.querySelector('[data-grid]');
            if (!newGrid || !grid) throw new Error('grid missing');

            Array.prototype.forEach.call(newGrid.children, function(card) {
              grid.appendChild(card);
            });

            /* re-bind swatch + QV on new cards */
            bindCardInteractions(grid);

            if (newLoadMore) {
              btn.setAttribute('href', newLoadMore.getAttribute('href'));
              btn.textContent = newLoadMore.textContent.trim();
              btn.classList.remove('is-loading');
            } else {
              btn.remove();
            }

            if (history.pushState) history.pushState({}, '', href);
          })
          .catch(function() {
            btn.textContent = 'Load more';
            btn.classList.remove('is-loading');
          });
      });
    }

    /* ── Quick View Drawer ────────────────────────── */
    var sectionId = root.id.replace('KB-COL-', '');
    var qvOverlay = document.getElementById('KB-QV-overlay-' + sectionId);
    var qvDrawer  = document.getElementById('KB-QV-drawer-' + sectionId);
    var qvBody    = document.getElementById('KB-QV-body-' + sectionId);

    var qvData = null;
    var currentImg = 0;

    function money(cents) {
      return (window.Shopify && Shopify.currency)
        ? (cents / 100).toFixed(2) + ' ' + Shopify.currency.active
        : 'Rs. ' + (cents / 100).toFixed(2);
    }
    function savePercent(now, was) { return Math.round((1 - now / was) * 100); }

    function openQV(product) {
      if (!qvOverlay || !qvDrawer || !qvBody) return;
      qvData = product;
      currentImg = 0;
      renderQV();
      qvOverlay.classList.add('is-open');
      qvDrawer.classList.add('is-open');
      qvDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeQV() {
      if (!qvOverlay || !qvDrawer) return;
      qvOverlay.classList.remove('is-open');
      qvDrawer.classList.remove('is-open');
      qvDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    if (qvOverlay) qvOverlay.addEventListener('click', closeQV);
    if (qvDrawer) {
      var closeBtn = qvDrawer.querySelector('.kb-qv__close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeQV);
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeQV();
    });

    function renderQV() {
      var p = qvData;
      var imgs = p.images.length ? p.images : [''];
      var selectedOpts = p.options.map(function(o) { return o.values[0] ? o.values[0].value : ''; });

      function getVariant() {
        return p.variants.find(function(v) {
          return v.options.every(function(o, i) { return o === selectedOpts[i]; });
        }) || p.variants[0];
      }

      function priceHTML(v) {
        var html = '<div class="kb-qv__price-row">';
        html += '<span class="kb-qv__price-now">' + money(v.price) + '</span>';
        if (v.compare_at_price > v.price) {
          html += '<span class="kb-qv__price-was">' + money(v.compare_at_price) + '</span>';
          html += '<span class="kb-qv__save">Save ' + savePercent(v.price, v.compare_at_price) + '%</span>';
        }
        html += '</div>';
        return html;
      }

      function galleryHTML() {
        var html = '<div class="kb-qv__main-wrap">';
        html += '<img class="kb-qv__main-img" src="' + (imgs[currentImg] || '') + '" alt="">';
        if (imgs.length > 1) {
          html += '<button class="kb-qv__nav kb-qv__nav--prev" data-dir="-1">&#8249;</button>';
          html += '<button class="kb-qv__nav kb-qv__nav--next" data-dir="1">&#8250;</button>';
          html += '<span class="kb-qv__count">' + (currentImg + 1) + '/' + imgs.length + '</span>';
        }
        html += '</div>';
        if (imgs.length > 1) {
          html += '<div class="kb-qv__thumbs">';
          imgs.forEach(function(src, i) {
            html += '<div class="kb-qv__thumb' + (i === currentImg ? ' is-active' : '') + '" data-thumb="' + i + '">';
            html += '<img src="' + src + '" alt="">';
            html += '</div>';
          });
          html += '</div>';
        }
        return html;
      }

      function optionsHTML() {
        var html = '';
        p.options.forEach(function(opt, oi) {
          html += '<div class="kb-qv__option">';
          var isColor = opt.name.toLowerCase().match(/colo(u?)r|shade/);
          html += '<div class="kb-qv__opt-label">' + opt.name + ': <em>' + selectedOpts[oi] + '</em></div>';
          if (isColor) {
            html += '<div class="kb-qv__swatches">';
            opt.values.forEach(function(vObj) {
              var active = vObj.value === selectedOpts[oi] ? ' is-active' : '';
              var bg = 'background:' + (vObj.swatch || (window.kbSwatchHex && window.kbSwatchHex(vObj.value)) || '#ccc') + ';';
              html += '<button class="kb-qv__sw' + active + '" style="' + bg + '" data-opt="' + oi + '" data-val="' + vObj.value.replace(/"/g,'&quot;') + '" title="' + vObj.value.replace(/"/g,'&quot;') + '"></button>';
            });
            html += '</div>';
          } else {
            html += '<div class="kb-qv__size-row">';
            opt.values.forEach(function(vObj) {
              var active = vObj.value === selectedOpts[oi] ? ' is-active' : '';
              html += '<button class="kb-qv__size-btn' + active + '" data-opt="' + oi + '" data-val="' + vObj.value.replace(/"/g,'&quot;') + '">' + vObj.value + '</button>';
            });
            html += '</div>';
          }
          html += '</div>';
        });
        return html;
      }

      var variant = getVariant();
      var html = galleryHTML();
      html += '<p class="kb-qv__vendor">' + (p.vendor || '') + '®</p>';
      html += '<h2 class="kb-qv__title">' + p.title + '</h2>';
      html += priceHTML(variant);
      html += '<p class="kb-qv__tax">Tax included. Shipping calculated at checkout.</p>';
      html += '<hr class="kb-qv__divider">';
      html += optionsHTML();
      html += '<div class="kb-qv__qty-wrap">';
      html += '<div class="kb-qv__qty-label">Quantity</div>';
      html += '<div class="kb-qv__qty-row">';
      html += '<button class="kb-qv__qty-btn" data-qty="-1">&#8722;</button>';
      html += '<span class="kb-qv__qty-num">1</span>';
      html += '<button class="kb-qv__qty-btn" data-qty="1">+</button>';
      html += '</div></div>';
      html += '<div class="kb-qv__actions">';
      html += '<button class="kb-qv__atc"' + (variant.available ? '' : ' disabled') + '>' + (variant.available ? 'Add to Cart' : 'Sold Out') + '</button>';
      html += '<a href="' + p.url + '" class="kb-qv__view-full">View Full Details</a>';
      html += '</div>';
      qvBody.innerHTML = html;
      bindQVEvents(getVariant);
    }

    function bindQVEvents(getVariant) {
      qvBody.querySelectorAll('.kb-qv__nav').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var imgs = qvData.images;
          currentImg = (currentImg + parseInt(this.dataset.dir) + imgs.length) % imgs.length;
          renderQV();
        });
      });
      qvBody.querySelectorAll('.kb-qv__thumb').forEach(function(th) {
        th.addEventListener('click', function() {
          currentImg = parseInt(this.dataset.thumb);
          renderQV();
        });
      });
      var mainWrap = qvBody.querySelector('.kb-qv__main-wrap');
      if (mainWrap && qvData.images.length > 1) {
        var sx = 0;
        mainWrap.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; }, { passive: true });
        mainWrap.addEventListener('touchend', function(e) {
          var d = e.changedTouches[0].clientX - sx;
          if (Math.abs(d) > 40) {
            currentImg = (currentImg + (d < 0 ? 1 : -1) + qvData.images.length) % qvData.images.length;
            renderQV();
          }
        }, { passive: true });
      }
      qvBody.querySelectorAll('.kb-qv__sw, .kb-qv__size-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var oi = parseInt(this.dataset.opt);
          var selectedOpts = qvData.options.map(function(o) { return o.values[0] ? o.values[0].value : ''; });
          qvBody.querySelectorAll('.kb-qv__sw.is-active, .kb-qv__size-btn.is-active').forEach(function(ab) {
            selectedOpts[parseInt(ab.dataset.opt)] = ab.dataset.val;
          });
          selectedOpts[oi] = this.dataset.val;
          qvBody.querySelectorAll('[data-opt="' + oi + '"]').forEach(function(b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');
          var variant = qvData.variants.find(function(v) {
            return v.options.every(function(o, i) { return o === selectedOpts[i]; });
          }) || qvData.variants[0];
          var priceEl = qvBody.querySelector('.kb-qv__price-row');
          var tmp = document.createElement('div');
          tmp.innerHTML = '<div class="kb-qv__price-row">'
            + '<span class="kb-qv__price-now">' + money(variant.price) + '</span>'
            + (variant.compare_at_price > variant.price
                ? '<span class="kb-qv__price-was">' + money(variant.compare_at_price) + '</span>'
                + '<span class="kb-qv__save">Save ' + savePercent(variant.price, variant.compare_at_price) + '%</span>'
                : '')
            + '</div>';
          priceEl.replaceWith(tmp.firstChild);
          qvBody.querySelectorAll('.kb-qv__opt-label')[oi].innerHTML = qvData.options[oi].name + ': <em>' + this.dataset.val + '</em>';
          var atc = qvBody.querySelector('.kb-qv__atc');
          atc.disabled = !variant.available;
          atc.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
          if (variant.image) {
            var idx = qvData.images.indexOf(variant.image);
            if (idx >= 0) {
              currentImg = idx;
              qvBody.querySelector('.kb-qv__main-img').src = variant.image;
              qvBody.querySelectorAll('.kb-qv__thumb').forEach(function(th) {
                th.classList.toggle('is-active', parseInt(th.dataset.thumb) === idx);
              });
            }
          }
          bindATC(variant.id);
        });
      });
      qvBody.querySelectorAll('.kb-qv__qty-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var numEl = qvBody.querySelector('.kb-qv__qty-num');
          var val = Math.max(1, parseInt(numEl.textContent) + parseInt(this.dataset.qty));
          numEl.textContent = val;
        });
      });
      bindATC(getVariant().id);
    }

    function bindATC(variantId) {
      var atc = qvBody.querySelector('.kb-qv__atc');
      if (!atc) return;
      atc.onclick = function() {
        var self = this;
        var qtyEl = qvBody.querySelector('.kb-qv__qty-num');
        var qty = qtyEl ? Math.max(1, parseInt(qtyEl.textContent) || 1) : 1;
        self.disabled = true;
        self.innerHTML = '<span class="kb-atc-spinner"></span>';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: qty }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.status) throw new Error(data.description || 'Error');
          self.innerHTML = '✓ Added!';
          closeQV();
          var cartDrawerEl = document.querySelector('cart-drawer');
          if (cartDrawerEl) {
            cartDrawerEl.classList.remove('is-empty');
            if (data.sections) {
              cartDrawerEl.renderContents({ id: variantId, sections: data.sections });
              if (typeof publish === 'function') publish('cart-update', { source: 'kb-col', cartData: data });
            } else {
              cartDrawerEl.open();
            }
          }
          setTimeout(function() { self.innerHTML = 'Add to Cart'; self.disabled = false; }, 2000);
        })
        .catch(function() { self.innerHTML = 'Add to Cart'; self.disabled = false; });
      };
    }

    /* ── Bind card-level interactions (swatch + QV trigger) ── */
    function bindCardInteractions(scope) {
      /* Swatch click → swap card image */
      scope.querySelectorAll('.kb-col__card-swatch').forEach(function(sw) {
        if (sw.dataset.bound === '1') return;
        sw.dataset.bound = '1';
        sw.addEventListener('click', function(e) {
          var imageUrl = this.dataset.image;
          if (!imageUrl) return;
          e.preventDefault();
          var card = this.closest('.kb-col__card');
          var img = card.querySelector('.kb-col__card-img');
          if (img) img.src = imageUrl;
          card.querySelectorAll('.kb-col__card-swatch').forEach(function(s) { s.classList.remove('is-active'); });
          this.classList.add('is-active');
        });
      });

      /* Quick-add (+) → open QV */
      scope.querySelectorAll('[data-qv-open]').forEach(function(btn) {
        if (btn.dataset.bound === '1') return;
        btn.dataset.bound = '1';
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var card = this.closest('.kb-col__card');
          var jsonEl = card.querySelector('.kb-qv-json');
          if (!jsonEl || !window.kbQvLoad) return;
          var qvBtn = this;
          qvBtn.classList.add('is-loading');
          qvBtn.setAttribute('aria-busy', 'true');
          window.kbQvLoad(jsonEl).then(openQV).catch(function (err) {
            console.error('QV load error', err);
            var link = card.querySelector('a[href*="/products/"]');
            if (link) window.location.href = link.href;
          }).then(function () {
            qvBtn.classList.remove('is-loading');
            qvBtn.removeAttribute('aria-busy');
          });
        });
      });
    }

    bindCardInteractions(root);
  }

  document.querySelectorAll('[data-kb-col]').forEach(initCollection);

  /* Expose for AJAX swap re-initialization */
  window.kbInitCollection = initCollection;

  /* Direct "Add to Cart" on collection cards (delegated → survives load-more/filter swaps) */
  if (!window.__kbColAtcBound) {
    window.__kbColAtcBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.kb-col__atc[data-direct-atc]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var orig = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span class="kb-atc-spinner"></span>';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Error');
        btn.innerHTML = '✓ Added!';
        var cd = document.querySelector('cart-drawer');
        if (cd) {
          cd.classList.remove('is-empty');
          if (data.sections) {
            cd.renderContents({ id: variantId, sections: data.sections });
            if (typeof publish === 'function') publish('cart-update', { source: 'kb-col-atc', cartData: data });
          } else { cd.open(); }
        }
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; }, 2000);
      })
      .catch(function () { btn.innerHTML = orig; btn.disabled = false; });
    });
  }
})();
